<template>
	<div>
		<SelectInline
			v-model="searchStatus"
			:characteristic-items="metaItems"
			:label-type="labelTypeApplication"
			single-choice
			@input="emitChangeEvent"
			label-type="application"
		/>
	</div>
</template>
<script>
import {isDefined} from "@/helper/Value";
import * as CharacteristicLabel from "@/helper/characteristic/Label";
import {mapState} from "vuex";
import SelectInline from "@/vue/characteristic/SelectInline";
import _ from "lodash";
import {SEARCH_STATUS__NON_SEARCHING} from "@/helper/characteristic/NaturalId";

export default {

	components: {
		SelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		questionnaire: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	data ()
	{
		let searchStatus = undefined;

		if (this.value?.searchStatus)
		{
			let valueSearchStatus = this.value.searchStatus;

			if (Array.isArray(valueSearchStatus))
			{
				valueSearchStatus = _.first(valueSearchStatus);
			}
			searchStatus = [valueSearchStatus];
		}

		return {
			searchStatus,
			labelTypeApplication: CharacteristicLabel.APPLICATION
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		metaItems ()
		{
			if (!this.questionnaire)
			{
				return this.meta.searchStatus;
			}

			return this.meta.searchStatus.filter(
				characteristic => characteristic.naturalId !== SEARCH_STATUS__NON_SEARCHING
			);
		},
		searchStatusValid ()
		{
			return isDefined(this.searchStatus);
		},
		dataValid ()
		{
			return this.searchStatusValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				searchStatus: this.searchStatus
			});
		},
	}
}
</script>
